var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66825 11.4681L10.8449 12.6447L17.8995 5.59005L19.0781 6.76856L10.8449 15.0017L5.54159 9.69838L6.72009 8.51988L8.49075 10.2906L9.66825 11.4681ZM9.66967 9.11163L13.7968 4.98438L14.9721 6.15961L10.8449 10.2868L9.66967 9.11163ZM7.31407 13.8242L6.13655 15.0017L0.833252 9.69838L2.01176 8.51988L3.18928 9.69747L3.18829 9.69838L7.31407 13.8242Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2Line);
export default __webpack_public_path__ + "static/media/check-2line.cc46e625427b40732fa1e036690e80ca.svg";
export { ForwardRef as ReactComponent };